module.exports = __webpack_public_path__ + "img/selected6-min.ddcc5e3d.png";